export enum DonateType {
  COIN,
  VOTE,
}
